export default "/_next/static/images/9b1e220e65f646b5798f949d28e6f786.jpg";